
var SelectedPaymentMethod = (function ($, _, Backbone, PromiseUtil, CheckoutSettings) {

    var FreePaymentMethod = Backbone.Model.extend();

    var SelectedPaymentMethod = Backbone.Model.extend({

        _freeMethod: new FreePaymentMethod({ PaymentType: CheckoutSettings.PaymentType.Direct }),

        initialize: function (attrs, opts) {
            this._payments = opts.payments;
            this._options = opts.order.get('DeliveryOptions');
            this._currentPackage = opts.order.get('DeliveryServicePackageDetail');
            this._summary = opts.order.get('Summary');
            this._availablePaymentOptions = opts.order.get('AvailablePaymentOptions');

            this.listenTo(opts.order, 'change', _.bind(this._onOrderChanged, this));
            this.listenTo(this._payments, 'selected', _.bind(this._onSelected, this));
            this.listenTo(opts.order, 'sync', _.bind(this._onOrderLoad, this));
            this.listenTo(this._options, 'change:Selected', _.bind(this._onDeliveryOptionChanged, this));
        },

        isEmpty: function () {
            return !Boolean(this.get('PaymentType')) && !Boolean(this.get('OrderPaymentType'));
        },

        isPending: function () {
            return !Boolean(this.get('PaymentType')) && Boolean(this.get('OrderPaymentType'));
        },

        isDirect: function () {
            return this.get('PaymentType') === this._freeMethod.get('PaymentType');
        },

        isApplicable: function () {
            return !!this.get('IsApplicable');
        },

        _isPaymentMethodApplicable: function (method) {
            var paymentMethod = method || this;
            var paymentType = paymentMethod.get('PaymentType');
            if (paymentType === this._freeMethod.get('PaymentType'))
                return true;

            var mappedPaymentOption = CheckoutSettings.PaymentTypeToPaymentOptions[paymentType];
            if (!mappedPaymentOption)
                return false;

            return _.some(this._availablePaymentOptions, function (po) { return po.Name.toLowerCase() === mappedPaymentOption.toLowerCase(); });
        },

        _onOrderChanged: function (order) {
            this._availablePaymentOptions = order.get('AvailablePaymentOptions');
            var isApplicable = this._isPaymentMethodApplicable();
            this.set({ IsApplicable: isApplicable });
        },

        _onSelected: function (val) {
            if (this.isDirect()) {
                return;
            } else {
                if (!!this.__wasSelectedBeforeDeliveryOptionChanged) {
                    this.__wasSelectedBeforeDeliveryOptionChanged = this._payments.getSelected();
                }
                this._select(val);
            }

            if (!this._isPaymentMethodApplicable() && !this.isEmpty()) {
                var option = this._options.first();
                option && option.select();
            }
        },

        _select: function (method) {
            this.clear({ silent: true });

            var isApplicable = this._isPaymentMethodApplicable(method);

            var firstOption = this._options.first();
            var data = _.extend(method ? method.toJSON() : {}, { IsApplicable: isApplicable, DeliveryType: isApplicable && this._options.deliveryType() || firstOption && firstOption.id });

            this.set(data);

        },

        _onOrderLoad: function (order) {
            if (order.get('IsEmpty')) {
                return;
            }

            this.listenTo(this._summary, 'change', _.bind(this._onTotalChange, this));
            this.listenTo(this._currentPackage, 'change', _.bind(this._onTotalChange, this));

            this._onTotalChange();
        },

        _onTotalChange: function () {
            var _total = this._summary.get('Total');
            var _package = this._currentPackage.toJSON();

            if (!_package.Purchased) {
                _total += _package.Amount;
            }

            if (_total === 0) {
                this._select(this._freeMethod);
            } else {
                var method = this._payments.getSelected();

                if (this._isPaymentMethodApplicable()) {
                    this._select(method);
                }
            }
        },

        _onDeliveryOptionChanged: function (model) {
            if (model.get('Selected')) {
                // NOTE: save previous payment method to restore it then
                this.__wasSelectedBeforeDeliveryOptionChanged = this._payments.getSelected();
                this.set('DeliveryType', model.id);
            } else if (this.__wasSelectedBeforeDeliveryOptionChanged) {
                this._payments.setSelected(this.__wasSelectedBeforeDeliveryOptionChanged.get('Token'));
                this._payments.getSelected().set('Selected', true);
                this.__wasSelectedBeforeDeliveryOptionChanged = null;
            }
        }
    });

    return SelectedPaymentMethod;
})($, _, Backbone, PromiseUtil, CheckoutSettings);
